<script lang="ts">
import { defineComponent as __MACROS_defineComponent } from "vue";
export default /*#__PURE__*/ __MACROS_defineComponent({
  name: 'MenuEntreprise'
});
</script>
<template>
  <ka-container
    code="menu-entreprise"
    :data="page.$info.menuEntreprise">
    <!-- Container 1 -->
    <ka-container code="container-1">
      <ka-icon
        code="icon"
        value="i-fa-solid:check-circle" />
      <ka-text
        code="pourquoi-matchers"
        :options="{
          href: { name: `hub-entreprise` },
          click: page.pourquoiMatchersClick
        }">
        <span v-html="t('menuEntreprise.container1.pourquoiMatchers.value', `Pourquoi Matchers ?`)" />
      </ka-text>
    </ka-container>
    <!-- Container 2 -->
    <ka-container code="container-2">
      <ka-icon
        code="icon-1"
        value="i-fa-solid:map" />
      <ka-text
        code="comment-ca-marche"
        :options="{
          href: { name: `hub-entreprise-Fonctionnement` },
          click: page.commentCaMarcheClick
        }">
        <span v-html="t('menuEntreprise.container2.commentCaMarche.value', `Comment ça marche ? `)" />
      </ka-text>
    </ka-container>
    <!-- Container 3 -->
    <ka-container
      code="container-3"
      :options="{
        href: { name: `Blog` },
        click: page.container3Click
      }">
      <ka-icon
        code="icon-2"
        value="i-fa-solid:book" />
      <ka-text
        code="blog"
        :options="{
          href: { name: `Blog` },
          click: page.blogClick
        }">
        <span v-html="t('menuEntreprise.container3.blog.value', `Blog`)" />
      </ka-text>
    </ka-container>
    <!-- Container 4 -->
    <ka-container
      code="container-4"
      :options="{
        href: `/experts`,
        ariaLabel: `container 4`,
        click: page.container4Click
      }">
      <ka-icon
        code="icon-3"
        value="i-fa-solid:search" />
      <ka-text
        code="rechercher-un-expert"
        :options="{
          href: `/experts`,
          ariaLabel: `text`,
          click: page.rechercherUnExpertClick
        }">
        <span v-html="t('menuEntreprise.container4.rechercherUnExpert.value', `Rechercher un expert `)" />
      </ka-text>
    </ka-container>
  </ka-container>
</template>

<script setup lang="ts">
import { syncPageStore } from 'kapix-components-vue3'
import { menuEntrepriseMenu } from './store'
import './style.scss'
import './style.custom.scss'


provide('$scoped', '--p47')
const page = menuEntrepriseMenu()

syncPageStore(page)
</script>
